import Firebase from 'firebase'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'

const joinGame = (gameId) => {
  return getGameInfo(gameId)
    .then(getPlayerInfo)
    .then(verifyThatThePlayerShouldJoin)
    .then(addPlayerToGame)
    .then( () => toast("Joined game"))
    .catch( error => {
      console.error("Error joining game: ", error)
      toast.error("Sorry, we couldn't add you to this game. " + error)
    })
}

const getGameInfo = (gameId) => {
  return Firebase.firestore().collection("games")
    .doc(gameId)
    .get()
    .catch(error => {
      console.error('Could not find game to join', error)
      return Promise.reject('Are you sure you have the right link?')
    })
}

const getPlayerInfo = (gameRef) => {
  return Firebase.firestore().collection("players")
    .where('game', '==', gameRef.id)
    .where('user', '==', Firebase.auth().currentUser.uid)
    .get()
    .then(playerRef => ({gameRef, playerRef}))
}

const verifyThatThePlayerShouldJoin = ({gameRef, playerRef}) => {
  if (!playerRef.empty) {
    return Promise.reject('Aleady in this game')
  }
  if (gameRef.data().started) {
    return Promise.reject('This game has already started!')
  }
  return({gameRef, playerRef})
}

const addPlayerToGame = ({gameRef, playerRef}) => {
  ReactGA.event({
    category: 'Game',
    action: 'Joined an existing game (all methods)',
  })
  return Firebase.firestore().collection("players").add({
    game: gameRef.id,
    user: Firebase.auth().currentUser.uid,
    name: Firebase.auth().currentUser.displayName,
    joinedAt: new Date(),
    alive: true,
    admin: false,
  })
}

export default joinGame



// WEBPACK FOOTER //
// ./src/actions/joinGame.js